import React from 'react';
import cx from 'classnames';

import styles from './VehicleHubProgressBar.module.scss';

export const ProgressPip: React.FC<{ progress: number; step: number }> = ({ progress, step }) => (
  <span className={cx(styles.pip, {
    [styles.completed]: progress >= step,
  })} style={{ '--pip-x': `${step}%` } as React.CSSProperties} />
);
